// extracted by mini-css-extract-plugin
module.exports = {"captach":"src-pages-guide-component-province-validator-jiangshu-captcha-__index__captach--3omw-"};